import { TranslationKeys } from '../../types/react-i18next';
import { HelpTabNavItem } from './types';

export const HELP_TAB_ENTITIES: ReadonlyArray<{
  value: HelpTabNavItem;
  path: TranslationKeys;
}> = [
  {
    value: HelpTabNavItem.ContactUs,
    path: 'help.paths.contactUs',
  },
  {
    value: HelpTabNavItem.Documentation,
    path: 'help.paths.documentation',
  },
  {
    value: HelpTabNavItem.GettingStartedVideo,
    path: 'help.paths.gettingStartedVideo',
  },
  {
    value: HelpTabNavItem.SafeguardsRuleReviewVideo,
    path: 'help.paths.safeguardsRuleReviewVideo',
  },
] as const;
